module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-view-resumenes-stevedore/master-view-resumenes-stevedore.component.scss
// module id = ./src/app/master/master-view-resumenes-stevedore/master-view-resumenes-stevedore.component.scss
// module chunks = main